import Homebutton from '../Homebutton';

function Monteurstool() {
  return (
    <div className='container'>
      <div className='container-box'>
        <h1 className='text-center'>Monteurs tool</h1>
        <h2 className='text-center'>Handleiding monteurs tool</h2>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusantium
          ea autem aspernatur porro aperiam consequuntur similique repellat
          veritatis a qui nihil maxime aliquid adipisci repellendus eum,
          perspiciatis molestiae totam, omnis rem commodi rerum facere in?
        </p>
        <p>
          <br />
        </p>
        <Homebutton />
      </div>
    </div>
  );
}

export default Monteurstool;
